import React from "react";

import styles from "./entryBox.scss";
import { getImageUrl } from "../../../services/asset";
import { RealEstateWidget } from "./RealEstateWidget";

interface RealEstatePricesEntryBoxProps {
  category?: string;
  flushBottom?: boolean;
}

const RealEstatePricesEntryBox = ({ category, flushBottom }: RealEstatePricesEntryBoxProps) => {

  return (
    <div className={`${styles.background} ${flushBottom ? styles.flushBottom : ""}`}>
      <img
        className={styles.banner}
        src={getImageUrl("real-estate-prices-banner.png")}
        alt=""
      />
      <div className={styles.container}>
        <RealEstateWidget category={category} label="Box naslovnica kategorije" />
      </div>
    </div>
  );
};

export default RealEstatePricesEntryBox;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/RealEstatePricesEntryBox/index.tsx